const CampaignStatus = {
  Upcoming: "upcoming",
  Ongoing: "ongoing",
  Ended: "ended",
  Cancelled: "cancelled",
};

export default CampaignStatus;
